module.exports = __webpack_public_path__ + "assets/images/Sample4.d16401f6.jpg";